module.exports = "../fonts/HelveticaNeueLTW01-56Italic.woff";


//////////////////
// WEBPACK FOOTER
// ./src/main/script/komodo/fonts/HelveticaNeueLTW01-56Italic.woff
// module id = B0C/
// module chunks = 1